import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {YearRangeTail} from '../../../core/models/YearRangeTail';
import * as _ from 'underscore';

@Component({
    selector: 'app-time-range-tail',
    templateUrl: './time-range-tail.component.html',
    styleUrls: ['./time-range-tail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimeRangeTailComponent implements OnInit, OnChanges {
    @Input()
    timeRangeTail: YearRangeTail;

    @Input()
    from: number;

    @Input()
    tailIndex: number;

    @Input()
    isLast: boolean;

    @Output() removeTimeRangeTail = new EventEmitter();

    @Output() toChange = new EventEmitter<number>();

    defaultTimeRangeList = [
        {value: 0.25, text: '1 week'},
        {value: 1, text: '1 month'},
        {value: 3, text: '3 months'},
        {value: 6, text: '6 months'},
        {value: 9, text: '9 months'},
        {value: 12, text: '1 year'}/*,
        {value: 18, text: '1.5 years'},
        {value: 24, text: '2 years'},
        {value: 36, text: '3 years'},
        {value: 48, text: '4 years'},
        {value: 60, text: '5 years'},
        {value: 72, text: '6 years'},
        {value: 84, text: '7 years'},
        {value: 96, text: '8 years'},
        {value: 108, text: '9 years'},
        {value: 120, text: '10 years'}*/
    ];
    tailValues = [0.005, 0.01, 0.02, 0.05, 0.1, 0.2, 0.25, 0.5, 0.75, 0.8, 0.9, 0.95, 0.98, 0.99, 0.995];
    timeRangeList = [];
    fromText = '0 month';

    constructor() {
    }

    ngOnInit() {
        if (this.isLast) {
            this.timeRangeTail.to = 120;
        }
        this.populateTimeRangeGreaterThanOrEqualToFromValue(this.timeRangeTail.from);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.from) {
            return;
        }

        if (+changes.from.currentValue > +this.timeRangeTail.to) {
            this.timeRangeTail.to = changes.from.currentValue;
            this.toChange.emit(this.timeRangeTail.to);
        }
        this.populateTimeRangeGreaterThanOrEqualToFromValue(changes.from.currentValue);
        _.each(this.defaultTimeRangeList, x => {
            if (x.value === changes.from.currentValue) {
                this.fromText = x.text;
            }
        });
    }

    public onRemoveTimeRangeTail() {
        this.removeTimeRangeTail.emit();
    }

    public onToChange(value) {
        this.toChange.emit(value);
    }

    public populateTimeRangeGreaterThanOrEqualToFromValue(fromValue) {
        this.timeRangeList = _.filter(this.defaultTimeRangeList, x => {
            return x.value >= fromValue;
        });
    }


}
